import React, { useEffect, useState } from "react";
import { Checkbox, Collapse } from "antd";
import { Link, useNavigate } from "react-router-dom";

import { message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { updatehotel } from "../../../../services/hotel";
import { updateHotel } from "../../../../reducer/loginReducer";
import NavigatingButtons from "../navigatingButtons";

const Policy = ({ decrementId }) => {
  const { hotelDetails } = useSelector((store) => store.login);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { Panel } = Collapse;

  const [policies, setPolicies] = useState({
    selectAll: false,
    generalPolicies: false,
    longStayBookings: false,
    tripleOccupancyPolicy: false,
    visitorsPolicy: false,
    childPolicy: false,
  });

  const onChange = (e, key) => {
    if (key === "selectAll") {
      for (let key of Object.keys(policies)) {
        policies[key] = e.target.checked;
      }
      setPolicies({ ...policies });
    } else {
      policies[key] = e.target.checked;

      if (!e.target.checked) {
        policies.selectAll = false;
        setPolicies({ ...policies });
        return;
      }
      // const arr = [];
      policies.selectAll = true;
      for (let key of Object.keys(policies)) {
        if (!policies[key]) {
          policies.selectAll = false;
        }
      }
      setPolicies({ ...policies });
    }
  };

  const onConfim = async () => {
    const newData = {
      ...hotelDetails,
      onBoardingStep: 8,
      generalPolicies: Boolean(policies.generalPolicies),
      longStayBookings: Boolean(policies.longStayBookings),
      tripleOccupancyPolicy: Boolean(policies.tripleOccupancyPolicy),
      visitorsPolicy: Boolean(policies.visitorsPolicy),
      childPolicy: Boolean(policies.childPolicy),
    };

    const payload = {
      hotelId: hotelDetails?.id,
      body: newData,
    };

    let response = await updatehotel(payload);

    if (Boolean(response)) {
      dispatch(updateHotel(response.data));
      navigate("/confirmed");
    } else {
      message.error("Something Went Wrong!");
    }
  };

  useEffect(() => {
    if (hotelDetails) {
      const data = {
        generalPolicies: Boolean(hotelDetails?.generalPolicies),
        longStayBookings: Boolean(hotelDetails?.longStayBookings),
        tripleOccupancyPolicy: Boolean(hotelDetails?.tripleOccupancyPolicy),
        visitorsPolicy: Boolean(hotelDetails?.visitorsPolicy),
        childPolicy: Boolean(hotelDetails?.childPolicy),
        selectAll: Boolean(
          hotelDetails?.generalPolicies &&
            hotelDetails?.longStayBookings &&
            hotelDetails?.tripleOccupancyPolicy &&
            hotelDetails?.visitorsPolicy &&
            hotelDetails?.childPolicy
        ),
      };
      setPolicies(data);
    }
  }, [hotelDetails]);

  return (
    <div>
      <div className="flex justify-between items-center">
        <h2 className="text-[2rem] font-[600] font-[Poppins] tracking-[0.07813rem] uppercase text-[#4f4f4f]">
          Guest Policies
        </h2>
      </div>

      <div className="mt-[20px] mb-[6rem]">
        <p className="text-[1.5rem] font-[400] font-nunito text-[#323F4B] mb-[45px]">
          Choose Guest policies applcicable to your hotel
        </p>

        <p className="mt-[52px] pl-4 mb-[28px] text-[22px]">
          <Checkbox
            onChange={(e) => onChange(e, "selectAll")}
            id="all"
            className="mr-[10px] cursor-pointer"
            checked={policies.selectAll}
          />
          <label htmlFor="all" className="cursor-pointer">
            Select All
          </label>
        </p>

        <Collapse
          className="border-0 policy"
          defaultActiveKey={["1", "2", "3", "4", "5"]}
        >
          <Panel
            className="border-0 pl-0"
            header={
              <p className="text-2xl text-[#007FFF] ">
                <Checkbox
                  onChange={(e) => onChange(e, "generalPolicies")}
                  id="general"
                  className="mr-[10px] cursor-pointer"
                  checked={policies.generalPolicies}
                />
                <label htmlFor="general" className="cursor-pointer">
                  General Policies
                </label>
              </p>
            }
            key="1"
          >
            <ol className="list-decimal list-inside bg-[#F9F9F9] p-3">
              <li className="text-sm">
                Couples are welcome. Guests can check in using any local or
                outstation ID proof
              </li>
              <li className="text-sm">
                General Booking Policy: Certain destinations may have different
                travel guidelines for specific times during the year. Please
                abide by all laws and guidelines as applicable
              </li>
              <li className="text-sm">
                Policies are booking specific and would be informed to the guest
                at the time of booking or upon Check-In.
              </li>
              <li className="text-sm">
                The primary guest must be at least 18 years of age to be able to
                check into the hotel.
              </li>
              <li className="text-sm">
                It is mandatory for guests to present valid photo identification
                at the time of check-in. According to government regulations, a
                valid Photo ID has to be carried by every person above the age
                of 18 staying at the hotel. The identification proofs accepted
                are Aadhar Card, Driving License, Voter ID Card, and Passport.
                Without Original copy of valid ID the guest will not be allowed
                to check-in.
              </li>
              <li className="text-sm">
                PAN card is not accepted as a valid ID card.
              </li>
              <li className="text-sm">
                Pets are not allowed in the hotel premises.
              </li>
              <li className="text-sm">
                Should any action by a guest be deemed inappropriate by the
                hotel, or if any inappropriate behaviour is brought to the
                attention of the hotel, the hotel reserves the right, after the
                allegations have been investigated, to take action against the
                guest.
              </li>
              <li className="text-sm">
                Guests shall be liable for any damage, except normal wear and
                tear to Hotel asset. Guest shall keep the Hotel room in a good
                condition and maintain hygiene and cleanliness.
              </li>
              <li className="text-sm">
                Extension of stay would be provided on current room rates,
                subject to availability. Current room rates can be different
                from the rates at which the rooms were booked.
              </li>
              <li className="text-sm">
                You agree that hotels may deny entry of visitors to rooms. You
                will be solely responsible for entry of any visitor to your
                room, You will be liable for any damage to hotel assets and use
                of the hotel must comply with all applicable local, state,
                national, and international laws, and that you will not use the
                hotel for any illegal purpose.
              </li>
              <li className="text-sm">
                We do not charge cancellation fees for bookings cancelled within
                10 minutes of creating the same booking. Any amount paid will be
                refunded. You can cancel your booking using our website or email
                .
              </li>
            </ol>
          </Panel>

          <Panel
            className="border-0 pl-0"
            header={
              <p className="text-2xl text-[#007FFF] ">
                <Checkbox
                  onChange={(e) => onChange(e, "longStayBookings")}
                  id="long"
                  className="mr-[10px] cursor-pointer"
                  checked={policies.longStayBookings}
                />
                <label htmlFor="long" className="cursor-pointer">
                  Long Stay Bookings
                </label>
              </p>
            }
            key="2"
          >
            <p className="text-sm bg-[#F9F9F9] p-3">
              For bookings of more than 7 nights, you have to settle all
              outstanding payments on a weekly basis. Further accommodation is
              subject to settlement of the outstanding amount.
            </p>
          </Panel>

          <Panel
            className="border-0 pl-0"
            header={
              <p className="text-2xl text-[#007FFF] ">
                <Checkbox
                  onChange={(e) => onChange(e, "tripleOccupancyPolicy")}
                  id="triple"
                  className="mr-[10px] cursor-pointer"
                  checked={policies.tripleOccupancyPolicy}
                />
                <label htmlFor="triple" className="cursor-pointer">
                  Triple Occupancy Policy
                </label>
              </p>
            }
            key="3"
          >
            <p className="text-sm bg-[#F9F9F9] p-3">
              Some Hotels allow triple occupancy by providing an extra mattress
              for the third person for extra fee. However no extra bed is
              usually provided.
            </p>
          </Panel>

          <Panel
            className="border-0 pl-0"
            header={
              <p className="text-2xl text-[#007FFF] ">
                <Checkbox
                  onChange={(e) => onChange(e, "visitorsPolicy")}
                  id="visitor"
                  className="mr-[10px] cursor-pointer"
                  checked={policies.visitorsPolicy}
                />
                <label htmlFor="visitor" className="cursor-pointer">
                  Visitor’s Policy
                </label>
              </p>
            }
            key="4"
          >
            <p className="text-sm bg-[#F9F9F9] p-3">
              a. Some Hotels allow triple occupancy by providing an extra
              mattress for the third person for extra fee. However no extra bed
              is usually provided.a. Visitors are generally allowed to meet
              guests in the guest rooms during the day, except if there is an
              emergency. <br />
              b. Visitors are not to be allowed to stay overnight.
              <br />
              c. The Hotel front desk requires all visitors to present a
              government approved photo identity prior to accessing guest
              floors/rooms.
            </p>
          </Panel>

          <Panel
            className="border-0 pl-0"
            header={
              <p className="text-2xl text-[#007FFF] ">
                <Checkbox
                  onChange={(e) => onChange(e, "childPolicy")}
                  id="child"
                  className="mr-[10px] cursor-pointer"
                  checked={policies.childPolicy}
                />
                <label htmlFor="child" className="cursor-pointer">
                  Child’s Policy
                </label>
              </p>
            }
            key="5"
          >
            <p className="text-sm bg-[#F9F9F9] p-3">
              Stay of 1 child up to 5 years of age is complementary without the
              use of an extra mattress. Breakfast charges may be applicable for
              the child.
            </p>
          </Panel>
        </Collapse>
      </div>

      <NavigatingButtons
        incrementId={onConfim}
        decrementId={decrementId}
      ></NavigatingButtons>
    </div>
  );
};

export default Policy;
